/**
 * External dependencies
 */
import React from "react";
import { connect } from "react-redux";

/**
 * Internal dependencies
 */
import { Box, Text } from "@towersystems/towersystems-design-system";
import Gravatar from "components/gravatar";
import { getCurrentUserEmail } from "state/current-user/selectors";

/**
 * Style dependencies
 */
import "./styles.scss";

const Topbar = (props) => {
  return (
    <Box className="topbar">
      <Box>
        <button className="topbar__gravatar-btn">
          <Gravatar />
        </button>
      </Box>
    </Box>
  );
};

export default connect((state) => ({
  email: getCurrentUserEmail(state),
}))(Topbar);
